// Sdílený výběr "za kterého trenéra se owner dívá".
//
// 4.9.2026: výběr se přestěhoval z pruhu uvnitř trenérského portálu rovnou do
// horní lišty aplikace. Lišta a portál jsou dvě různé části stromu, takže
// hodnotu drží localStorage a změnu rozhlásí událost na window. Díky tomu se
// obě strany překreslí bez ohledu na to, kdo přepnul.
import { useEffect, useState } from "react";

export const KLIC_NAHLEDU = "fw40_view_as_trener";
export const UDALOST_NAHLEDU = "fw40:nahled-trenera";

export function nactiNahled() {
  try {
    return localStorage.getItem(KLIC_NAHLEDU) || "";
  } catch {
    return "";
  }
}

export function nastavNahled(hodnota) {
  const v = hodnota || "";
  try { localStorage.setItem(KLIC_NAHLEDU, v); } catch { /* ignoruj */ }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(UDALOST_NAHLEDU, { detail: v }));
  }
}

/** Vrací [jméno trenéra, setter]. Setter zapíše hodnotu i rozhlásí změnu. */
export function useNahledTrenera() {
  const [jmeno, setJmeno] = useState(nactiNahled);
  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const naZmenu = (e) => setJmeno(e?.detail || "");
    // storage: kdyby si owner otevřel appku ve dvou záložkách
    const naStorage = (e) => { if (e.key === KLIC_NAHLEDU) setJmeno(e.newValue || ""); };
    window.addEventListener(UDALOST_NAHLEDU, naZmenu);
    window.addEventListener("storage", naStorage);
    return () => {
      window.removeEventListener(UDALOST_NAHLEDU, naZmenu);
      window.removeEventListener("storage", naStorage);
    };
  }, []);
  return [jmeno, nastavNahled];
}
